import api from './config';
import { DatabaseMessage, Message } from '../types/types';

const MESSAGE_API_URL = `${process.env.REACT_APP_SERVER_URL}/messaging`;

/**
 * Adds a new message to a specific chat with the given id.
 *
 * @param messageToAdd - The message object to add to the chat.
 * @throws an error if the request fails or the response status is not 200.
 */
const addMessage = async (messageToAdd: Message): Promise<DatabaseMessage> => {
  const res = await api.post(`${MESSAGE_API_URL}/addMessage`, { messageToAdd });
  if (res.status !== 200) {
    throw new Error('Error while adding message');
  }
  return res.data;
};

/**
 * Function to fetch all messages in ascending order of their date and time.
 * @param type - The type of chat to fetch messages from. It can be 'Global', 'Direct', 'Game', or 'Watch'.
 * @param contextID - The ID of the context (game or watch) to fetch messages from. This is optional and only used for 'Game' or 'Watch' types.
 * @throws Error if there is an issue fetching the list of chats.
 */
const getMessages = async (
  type: 'global' | 'direct' | 'game' | 'watch',
  contextID?: string,
): Promise<DatabaseMessage[]> => {
  const params = new URLSearchParams();
  params.append('type', type);
  params.append('contextID', contextID || '');
  if (contextID) params.append('contextID', contextID);
  const res = await api.get(`${MESSAGE_API_URL}/getMessages`, { params });

  if (res.status !== 200) {
    throw new Error('Error when fetching messages');
  }
  return res.data;
};

export { addMessage, getMessages };
